module.exports = __webpack_public_path__ + "img/b83306d.jpg";